import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";

export const TreatmentOriginItem = ({ id, name }) => {
  const { darkMode } = useContext(ThemeContext);

  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        width: "370px",
        height: "110px",
        padding: 1,
        borderRadius: "5px",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: darkMode
          ? getColors.thumbnailBorderDark
          : getColors.thumbnailBorderLight,
        background: darkMode
          ? getColors.thumbnnailBgDark
          : getColors.thumbnnailBgLight,
        cursor: "pointer",
        "&:hover": {
          borderColor: darkMode
            ? getColors.thumbnailTextDark
            : getColors.thumbnailTextLight,
        },
      }}
    >
      <Box display={"flex"} alignItems={"center"}>
        <Typography
          sx={{
            fontSize: "22px",
            fontWeight: 500,
            color: darkMode
              ? getColors.drawerTextDark
              : getColors.thumbnailTextLight,
            ml: "20px",
          }}
        >
          {name}
        </Typography>
      </Box>
    </Box>
  );
};
